import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=5a4a57b2&scoped=true&"
import script from "./Policy.js?vue&type=script&lang=js&"
export * from "./Policy.js?vue&type=script&lang=js&"
import style0 from "./Policy.css?vue&type=style&index=0&id=5a4a57b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4a57b2",
  null
  
)

export default component.exports